// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/notebook/v1/document_service.proto (package chalk.notebook.v1, syntax proto3)
/* eslint-disable */

import { NotebookDocumentService } from "./document_service_pb";

/**
 * Mints a share link. The response carries the only copy of the secret URL.
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.CreateNotebookShareLink
 */
export const createNotebookShareLink = NotebookDocumentService.method.createNotebookShareLink;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookShareLinks
 */
export const listNotebookShareLinks = NotebookDocumentService.method.listNotebookShareLinks;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.RevokeNotebookShareLink
 */
export const revokeNotebookShareLink = NotebookDocumentService.method.revokeNotebookShareLink;

/**
 * The share-link viewer's entry point: exchanges the token in the request
 * headers for the identity of the notebook it grants. Deliberately the only
 * way a holder learns that notebook id, which the read RPCs below then
 * require -- so a token never doubles as a way to enumerate the environment.
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ResolveNotebookShareLink
 */
export const resolveNotebookShareLink = NotebookDocumentService.method.resolveNotebookShareLink;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.CreateNotebookComment
 */
export const createNotebookComment = NotebookDocumentService.method.createNotebookComment;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookComments
 */
export const listNotebookComments = NotebookDocumentService.method.listNotebookComments;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.DeleteNotebookComment
 */
export const deleteNotebookComment = NotebookDocumentService.method.deleteNotebookComment;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.SetNotebookCommentResolved
 */
export const setNotebookCommentResolved = NotebookDocumentService.method.setNotebookCommentResolved;

/**
 * Adds the caller's reaction with the given emoji, or removes it when the
 * caller already reacted with that emoji.
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ToggleNotebookCommentReaction
 */
export const toggleNotebookCommentReaction = NotebookDocumentService.method.toggleNotebookCommentReaction;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.CreateNotebookDocument
 */
export const createNotebookDocument = NotebookDocumentService.method.createNotebookDocument;

/**
 * internal.resource_share_view is accepted alongside deploy.read and
 * notebook.write, so share-link holders use the signed-in read endpoint. The
 * permission only decides that a share token may call this RPC; the handler
 * is what confines it to the one notebook the token names.
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.GetNotebookDocument
 */
export const getNotebookDocument = NotebookDocumentService.method.getNotebookDocument;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookDocuments
 */
export const listNotebookDocuments = NotebookDocumentService.method.listNotebookDocuments;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.UpdateNotebookDocument
 */
export const updateNotebookDocument = NotebookDocumentService.method.updateNotebookDocument;

/**
 * Returns the id of the Dashboard row backing this notebook's app view,
 * creating it (empty, owner_type="notebook") and linking it to the document
 * in one transaction on first call. Idempotent.
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.EnsureNotebookApp
 */
export const ensureNotebookApp = NotebookDocumentService.method.ensureNotebookApp;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.DeleteNotebookDocument
 */
export const deleteNotebookDocument = NotebookDocumentService.method.deleteNotebookDocument;

/**
 * Archives or restores a notebook by setting/clearing archived_at. Archived
 * notebooks are excluded from the default list (ListNotebookDocuments with
 * include_archived=false) but are not soft-deleted.
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.SetNotebookArchived
 */
export const setNotebookArchived = NotebookDocumentService.method.setNotebookArchived;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.AddNotebookCell
 */
export const addNotebookCell = NotebookDocumentService.method.addNotebookCell;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.UpdateNotebookCell
 */
export const updateNotebookCell = NotebookDocumentService.method.updateNotebookCell;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.DeleteNotebookCell
 */
export const deleteNotebookCell = NotebookDocumentService.method.deleteNotebookCell;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.MoveNotebookCell
 */
export const moveNotebookCell = NotebookDocumentService.method.moveNotebookCell;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.BatchUpdateNotebookCells
 */
export const batchUpdateNotebookCells = NotebookDocumentService.method.batchUpdateNotebookCells;

/**
 * Persists the run plan and launches execution server-side; execution is
 * not tied to any client connection. Observe progress via WatchNotebookRun.
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.StartNotebookRun
 */
export const startNotebookRun = NotebookDocumentService.method.startNotebookRun;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.InterruptNotebookRun
 */
export const interruptNotebookRun = NotebookDocumentService.method.interruptNotebookRun;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookCellResults
 */
export const listNotebookCellResults = NotebookDocumentService.method.listNotebookCellResults;

/**
 * Pages through the full data behind a dataframe output chunk (blob-backed
 * Arrow artifacts, inline previews, SQL results), beyond the persisted
 * preview rows.
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.FetchNotebookDataframeRows
 */
export const fetchNotebookDataframeRows = NotebookDocumentService.method.fetchNotebookDataframeRows;

/**
 * Reduces one column of a dataframe output chunk to a single value over the
 * FULL backing artifact (blob-backed Arrow, inline arrow bytes) — used by
 * single-value elements whose source is larger than the persisted preview.
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.AggregateNotebookDataframe
 */
export const aggregateNotebookDataframe = NotebookDocumentService.method.aggregateNotebookDataframe;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookCellRunHistory
 */
export const listNotebookCellRunHistory = NotebookDocumentService.method.listNotebookCellRunHistory;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookDocumentRevisions
 */
export const listNotebookDocumentRevisions = NotebookDocumentService.method.listNotebookDocumentRevisions;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookRuns
 */
export const listNotebookRuns = NotebookDocumentService.method.listNotebookRuns;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.GetNotebookRunDetails
 */
export const getNotebookRunDetails = NotebookDocumentService.method.getNotebookRunDetails;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ClearNotebookCellResults
 */
export const clearNotebookCellResults = NotebookDocumentService.method.clearNotebookCellResults;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.GetNotebookSqlCacheSettings
 */
export const getNotebookSqlCacheSettings = NotebookDocumentService.method.getNotebookSqlCacheSettings;

/**
 * Environment-wide cache policy is the admin knob; notebook/cell overrides
 * ride UpdateNotebookDocument/UpdateNotebookCell at editor tier.
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.UpdateNotebookSqlCacheSettings
 */
export const updateNotebookSqlCacheSettings = NotebookDocumentService.method.updateNotebookSqlCacheSettings;

/**
 * Provisions (or returns the existing) kernel runtime for a notebook: a
 * notebooks runtime row plus a chalk_nb_server container bound to this
 * notebook's session id. Idempotent — a second call returns the current
 * status without creating a duplicate container. Container creation is
 * synchronous but readiness (a routable web URL) is asynchronous, so a fresh
 * provision returns PROVISIONING and callers poll GetNotebookRuntimeStatus.
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.StartNotebookRuntime
 */
export const startNotebookRuntime = NotebookDocumentService.method.startNotebookRuntime;

/**
 * Stops the runtime container and marks the notebooks row stopped. Idempotent.
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.StopNotebookRuntime
 */
export const stopNotebookRuntime = NotebookDocumentService.method.stopNotebookRuntime;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.GetNotebookRuntimeStatus
 */
export const getNotebookRuntimeStatus = NotebookDocumentService.method.getNotebookRuntimeStatus;

/**
 * Lists live kernel runtimes (non-stopped notebooks with a non-stopped
 * backing container) in the request's environment. State is resolved per row
 * the same way GetNotebookRuntimeStatus resolves it for a single notebook.
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookRuntimes
 */
export const listNotebookRuntimes = NotebookDocumentService.method.listNotebookRuntimes;

/**
 * Lists the Python packages installed in a notebook's running kernel by
 * proxying to the kernel's ListInstalledPackages RPC (cached per container).
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookKernelPackages
 */
export const listNotebookKernelPackages = NotebookDocumentService.method.listNotebookKernelPackages;

/**
 * Assembles the notebook's variable data-flow DAG: nodes are runnable cells,
 * edges are last-producer-wins dependencies. Provides/requires come from the
 * kernel's AST analysis (AnalyzeNotebookCellDependencies), not a server-side
 * line parser. Returns an empty graph when no kernel runtime is reachable.
 *
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.GetNotebookDependencyGraph
 */
export const getNotebookDependencyGraph = NotebookDocumentService.method.getNotebookDependencyGraph;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.ListNotebookSecrets
 */
export const listNotebookSecrets = NotebookDocumentService.method.listNotebookSecrets;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.GetNotebookSecretValue
 */
export const getNotebookSecretValue = NotebookDocumentService.method.getNotebookSecretValue;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.UpsertNotebookSecret
 */
export const upsertNotebookSecret = NotebookDocumentService.method.upsertNotebookSecret;

/**
 * @generated from rpc chalk.notebook.v1.NotebookDocumentService.DeleteNotebookSecret
 */
export const deleteNotebookSecret = NotebookDocumentService.method.deleteNotebookSecret;
